export class videoModalModule {
	videoModalToggle: NodeList = document.querySelectorAll("[data-toggle-video-modal]");
	videoModalToggleArray: HTMLElement[] = Array.prototype.slice.call(this.videoModalToggle);
	videoModal: HTMLElement = document.querySelector("[data-video-modal]");
	videoModalClose: NodeList = document.querySelectorAll("[data-video-modal-close]");
	videoModalCloseArray: HTMLElement[] = Array.prototype.slice.call(this.videoModalClose);
	videoModalError: HTMLElement = document.querySelector("[data-video-modal-error]");
	videoModalContent: HTMLElement = document.querySelector("[data-video-modal-content]");
	activeClass: string = "is-active";

	constructor() {
		this.appendUrl();
		this.toggleModal();
	}
	// append url to modal
	private appendUrl = () => {
		this.videoModalToggleArray.forEach((elem) => {
			elem.addEventListener("click", () => {
				const targetIframe: string = elem.firstElementChild.getAttribute("data-iframe-id");
				if (targetIframe !== "") {
					this.videoModalContent.innerHTML = "<iframe class='iframe-item' src='https://www.youtube.com/embed/" + targetIframe + "?autoplay=1" + "' frameborder='0' allowfullscreen='' allow='accelerometer; autoplay'></iframe>";
				} else {
					this.videoModalError.classList.add(this.activeClass);
				}
			});
		});
	}

	private toggleModal = () => {
		// open modal
		this.videoModalToggleArray.forEach((elem) => {
			elem.addEventListener("click", () => {
				this.videoModal.classList.add(this.activeClass);
			});
		});
		// close modal
		const closeModal = () => {
			this.videoModal.classList.remove(this.activeClass);
			// clear iframe, so it dosent run in background
			setTimeout(() => {
				document.querySelector(".iframe-item").removeAttribute("src");
			}, 1200);
		};
		this.videoModalCloseArray.forEach(elem => elem.addEventListener("click", closeModal));
	}
}